import { render, staticRenderFns } from "./clickplay.vue?vue&type=template&id=b813c0ea&scoped=true&"
import script from "./clickplay.vue?vue&type=script&lang=js&"
export * from "./clickplay.vue?vue&type=script&lang=js&"
import style0 from "./clickplay.vue?vue&type=style&index=0&id=b813c0ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b813c0ea",
  null
  
)

export default component.exports